import { useQuery } from "@tanstack/react-query";
import { getUserData } from "../services/auth";

const USER_QUERY_KEY = ["user_db"] as const;

export default function useGetUserData() {
  return useQuery({
    queryKey: USER_QUERY_KEY,
    queryFn: getUserData,
    retry: 0, // 🔧 Disabilitiamo retry - se l'utente non esiste, è normale
    staleTime: 1000 * 60 * 2,
    refetchOnMount: false, // 🔧 Non refetch al mount
    refetchOnWindowFocus: false, // 🔧 Non refetch al focus
  });
}
